module.exports = __webpack_public_path__ + "img/insideBg.e7d84384.png";